import React from 'react';

import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Icon } from 'apps/auth/components/common/Icon/Icon';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { PanelContent, PanelFrame, PanelRightBlock } from 'apps/auth/components/common/Panel/styles';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_IMAGES_CURRENCIES } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

import { DiskBadgeWrapper } from '../styles';
import { GA_POCKET_TO_SUBSCRIPTION } from '../utils';

const AccountPaymentMethod = (props) => {
    const { gotIt, notEnoughBalanceText1 } = usePageMessages();

    const isNotEnoughFunds = () => {
        const balance = props.account?.balance;
        const subscriptionFee = props.tariff?.amount;
        return balance < subscriptionFee;
    };

    const isDisabledAccount = isNotEnoughFunds();

    const getPopup = () => {
        return (
            <SimplePopup text={notEnoughBalanceText1} popupRef={props.popupRef}>
                <PopupButton iconName="check" text={gotIt} onClick={() => props.popupRef.current?.close()} />
            </SimplePopup>
        );
    };

    const onClickHandler = (e) => {
        if (isDisabledAccount) {
            e.preventDefault();
            props.popupRef.current?.open(getPopup());
        } else {
            props.openClick(null, GA_POCKET_TO_SUBSCRIPTION);
        }
    };

    const defaultCurrencyIcon = `${URL_IMAGES_CURRENCIES}/currency-default.svg`;
    const getCurrencyIcon = (name) => {
        return `${URL_IMAGES_CURRENCIES}/currency-${name}.svg`;
    };
    const onIconRenderError = (e) => {
        e.target.onerror = null;
        e.target.src = defaultCurrencyIcon;
    };

    const alias = `${props.account.balance}  ${props.account.pocketCurrency.code}`;
    return (
        <Panel onClick={onClickHandler} negativeMargin isHoverable>
            <PanelFrame>
                <DiskBadgeWrapper>
                    <DiskBadge
                        isDisabled={isDisabledAccount}
                        src={getCurrencyIcon(props.account.currencyIcon)}
                        alt={props.account.currencyIcon}
                        onError={onIconRenderError}
                    />
                </DiskBadgeWrapper>
                <PanelContent>
                    <Text color={isDisabledAccount ? 'secondary' : 'primary'}>{alias}</Text>
                </PanelContent>
                {isDisabledAccount && (
                    <PanelRightBlock>
                        <Icon name={'alert'} size={'16px'} color={'lightGray'} />
                    </PanelRightBlock>
                )}
            </PanelFrame>
        </Panel>
    );
};

export default AccountPaymentMethod;
